module.exports = __webpack_public_path__ + "static/img/yanjiubaogao.7a0470a9.png";